import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav"
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom"; 


const ClientInvoiceCreate = ()=>{
     const [clientList, setClientList ] = useState([]);
     const[productList,setProductList] = useState([]);
     const [client,setClient] = useState('');
     const [product, setProduct ] = useState('');
     //const [quantity, setQuantity ] = useState('');
     const [page, setPage] = useState(1);
     const [total, setTotal ] = useState('');
     const [purchaseDate, setPurchaseDate ] = useState('');
     const [redirect, setRedirect] = useState(false);

     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`client?page=${page}`);
            setClientList(data.data);
            console.log(data); 

        }
        )();
    },[page]);

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`product?page=${page}`);
            setProductList(data.data);
            console.log(data); 

        }
        )();
    },[page]);

     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('clientInvoice', {
            client_id:parseInt(client),
            product_id:parseInt(product),
            total:parseFloat(total),
            purchase_date:purchaseDate,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/clientInvoice'} />
    }
     return (
         <Wrapper pageTitle={"New ClientInvoice"}>
            <InnerNav createLink={'/clientInvoiceCreate'} listLink={'/clientInvoice'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    
                        <select onChange={(e) => setClient(e.target.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input ">
                            <option value="0">Choose Client</option>
                            {clientList.map(client => (
                                <option key={client.id} value={client.id}>
                                    {client.name}
                                </option>
                            ))}
                        </select>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Product </span>
                        <select onChange={(e) => setProduct(e.target.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input ">
                            <option value="0">Choose Product</option>
                            {productList.map(product => (
                                <option key={product.id} value={product.id}>
                                    {product.name}
                                </option>
                            ))}
                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Total Amount</span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Total"
                        onChange = {e => setTotal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Purchase Date </span>
                        <input type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Purchasedate"
                        onChange = {e => setPurchaseDate(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default ClientInvoiceCreate;